module.exports = __webpack_public_path__ + "static/media/logo.ae273a81.svg";